import { isConsoleLogVisible } from './config';

const ConsoleUtils = {
  log: (message, data = null) => {
    if (isConsoleLogVisible)
      console.log(`%c[LOG]: ${message}`, 'color: blue; font-weight: bold;', data);
  },

  warn: (message, data = null) => {
    if (isConsoleLogVisible)
      console.warn(`%c[WARN]: ${message}`, 'color: orange; font-weight: bold;', data);
  },

  error: (message, data = null) => {
    if (isConsoleLogVisible)
      console.error(`%c[ERROR]: ${message}`, 'color: red; font-weight: bold;', data);
  },

  info: (message, data = null) => {
    if (isConsoleLogVisible)
      console.info(`%c[INFO]: ${message}`, 'color: green; font-weight: bold;', data);
  },
};

export default ConsoleUtils;
